<template>
  <el-container class="mainPage">
    <div class="mask" v-show="isSignOut"></div>
    <el-header
      style="text-align: right; font-size: 12px"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
      v-show="!this.$store.state.isScreen"
    >
      <div class="header_left">
        <i class="header-logo"></i>
        <div class="colleges">
          <span v-if="titleName">文秘专业教学资源库学习应用推广数据跟踪服务平台</span>
          <span v-else>资源库学习应用推广服务</span>
          <!-- <div class="pull_down">
            <div>big data platform for higher vocational colleges</div>
          </div> -->
        </div>
        <div class="table-search-box" v-if="userType == 1">
          <el-form :inline="true" :model="formResourceBase">
            <el-form-item label="">
              <el-select
                size="small"
                v-model="formResourceBase.dataSourcess"
                placeholder="切换专业"
                filterable
                :popper-append-to-body="false"
                @change="dataChange"
              >
                <el-option
                  v-for="item in dataSourcesList"
                  :key="item.zykId"
                  :label="item.zykName"
                  :value="item.zykId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <div class="radio-select-box">
                <el-radio-group v-model="statusRadio" @input="radioChange">
                  <el-radio label="1">国家级</el-radio>
                  <el-radio label="2">省级</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="header_right">
        <div class="user_name">
          您好！
          <span>{{ userName }}</span>
        </div>
        <div @click="signOut" class="pointer">
          <i class="el-icon-switch-button"></i>
          退出
        </div>
      </div>
    </el-header>

    <el-container class="mainPage" style="background: #000">
      <el-aside
        :style="{
          overflow: this.$store.state.isVague ? 'hidden' : '',
          width: !isCollapse ? '280px' : '104px',
        }"
        v-show="!this.$store.state.isScreen"
      >
        <div
          class="aside_Virtualization"
          :style="{
            top: this.$store.state.isVague ? '10px' : '70px',
            width: !isCollapse ? '265px' : '90px',
          }"
        ></div>
        <div class="aside_menu" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
          <el-menu
            text-color="#bcc2cf"
            :default-active="tagsMenu.path"
            router
            unique-opened
            @select="selectMenu"
            :collapse="isCollapse"
          >
            <template v-for="item in routerList">
              <template v-if="!item.children">
                <el-menu-item :index="item.path" :key="item.path">
                  <i
                    class="icons"
                    :class="tagsMenu.path === item.path ? item.suIcon : item.uicon"
                  ></i>
                  <span slot="title">{{ item.name }}</span>
                </el-menu-item>
              </template>

              <template v-else>
                <el-submenu :index="item.path" :key="item.index">
                  <template slot="title">
                    <i
                      class="icons"
                      :class="tagsMenu.path === item.path ? item.suIcon : item.uicon"
                    ></i>
                    <span>{{ item.name }}</span>
                  </template>

                  <template v-for="(e, i) in item.children">
                    <template v-if="!e.children">
                      <el-menu-item :index="e.path" :key="e.path">
                        <!-- <i class="el-icon-setting"></i> -->
                        <span slot="title">{{ e.name }}</span>
                      </el-menu-item>
                    </template>
                    <template v-else>
                      <el-submenu :index="e.path" :key="i">
                        <template slot="title">{{ e.name }}</template>
                        <el-menu-item-group v-for="(items, i) in e.children" :key="i + 0.1">
                          <el-menu-item :index="items.path">{{ items.name }}</el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                    </template>
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-menu>
        </div>
      </el-aside>
      <el-main
        :style="{
          left:
            !isCollapse && !this.$store.state.isScreen
              ? '280px'
              : isCollapse && !this.$store.state.isScreen
              ? '108px'
              : '0px',
          top: !this.$store.state.isScreen ? '60px' : '0px',
        }"
      >
        <div class="gadget" @click="stowSidebar">
          <i class="el-icon-arrow-left" v-if="!isCollapse"></i>
          <i class="el-icon-arrow-right" v-else></i>
          <!-- <i class="shrinkSidebar icon icon-shrinkSidebar" @click="stowSidebar" v-show="!isCollapse"></i>
          <i class="shrinkSidebar shrinkRight icon icon-shrinkSidebar" @click="isCollapse = !isCollapse" v-show="isCollapse"></i> -->
        </div>
        <img src="../assets/img/spherical.png" class="bgSpherical" />
        <div class="content-box">
          <div
            :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
            v-show="!this.$store.state.isScreen"
          >
            <div class="tabBar">
              <div class="tabBar_Virtualization"></div>
              <div class="tabBar_roll">
                <el-scrollbar ref="elscrollbar">
                  <el-tag
                    v-for="(item, index) in tagsList"
                    :key="item.name"
                    :closable="item.path != '/essential'"
                    disable-transitions
                    @click="clickTab(item)"
                    @close="closeTab(index)"
                    :class="activeTab == item.path ? 'acitveTags' : ''"
                  >
                    <!--鼠标右键 @contextmenu.prevent.native="rightMouse($event, item, index)" -->
                    <i class="icon-whiteIcon"></i>
                    {{ item.name }}
                  </el-tag>
                </el-scrollbar>
              </div>
              <!-- 左右切换 -->
              <div class="arrowCut">
                <div class="vague"></div>
                <i class="icon-leftSwitch pointer" @click="arrowCutLeft"></i>
                <i class="icon-rightSwitch pointer" @click="arrowCutRight"></i>
              </div>
            </div>
            <!-- <div v-if="visible" class="rightMouse" :style="{ left: mouse.left + 'px', top: mouse.top + 'px' }">
              <div @click="closeOther">关闭其它</div>
              <div @click="closeAll">关闭所有</div>
            </div> -->
          </div>

          <div :class="this.$store.state.isScreen ? 'isFullscreen' : 'roll_page'">
            <transition name="move" mode="out-in">
              <router-view v-if="isRouterAlive" ref="child"></router-view>
            </transition>
            <el-button class="screen" type="primary" @click="full">
              <span v-if="!isFull">全屏</span>
              <span v-else>取消全屏</span>
            </el-button>
            <div class="center-btn">
              <!-- <el-button class="btn-save" type="primary" @click="saveTable" v-if="showSaveBtn"
                >保存</el-button
              > -->
              <el-button class="btn-save" type="primary" @click="exportTable" v-if="showExportBtn"
                >导出PDF</el-button
              >
            </div>
            <!-- <el-backtop target=".mainPage"></el-backtop> -->
          </div>

          <div class="footer" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
            <div class="footer_text">
              ©国开视通(北京)软件技术有限公司&nbsp;|&nbsp;<a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                style="color: white"
                target="_blank"
                >京ICP备19007517号-1</a
              >&nbsp;|&nbsp; <img src="../assets/img/public_security.png" alt="" /><a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039953"
                style="color: white"
                >京公网安备 11010802039953号</a
              >&nbsp;|&nbsp;隐私政策 | 法律声明
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// import routes from '../router/index'
import screenfull from "screenfull";
import circularChart from "@/components/chart/circularChart.vue";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      isRouterAlive: true, // 控制视图是否显示的变量
      dataSourcesList: [], // 数据源
      // dataSourcess: '',  //选中的数据源
      routeMenu: [], // 路由列表
      routerList: [], // 路由菜单
      tagsList: [], // tag选项卡
      activeTab: "", // 当前选中的tages
      tagsMenu: {
        // 选中的菜单
        name: "",
        path: "",
      },
      visible: false, // 弹出选择菜单
      tagitem: {},
      tagindex: "",
      mouse: {
        left: 0,
        top: 0,
      },
      maxClickNum: 0, // 最大点击次数
      lastLeft: 0, // 上次滑动距离
      clickNum: 0, // 点击次数,
      isCollapse: false,
      userName: "",
      formResourceBase: {
        dataSourcess: "",
      },
      isFull: false, // 是否全屏
      userType: 0,
      isSignOut: false,
      titleName: false,
      showSaveBtn: false, //判断是否显示保存按钮
      showExportBtn: false, //判断是否显示导出按钮
    };
  },
  created() {
    this.routeMenu = JSON.parse(this.$Utils.demoResponse(sessionStorage.getItem("menu")));

    this.routerlist();
    if (sessionStorage.getItem("userName")) {
      this.userName = sessionStorage.getItem("userName");
    } else {
      this.userName = "用户";
    }
    if (sessionStorage.getItem("tagsList")) {
      this.tagsList = JSON.parse(sessionStorage.getItem("tagsList"));
      this.tagsMenu.path = JSON.parse(sessionStorage.getItem("selectMenu")).path;
      this.activeTab = JSON.parse(sessionStorage.getItem("selectMenu")).path;
      this.$router.replace(this.activeTab);
    }
  },
  computed: {
    statusRadio: {
      get() {
        return this.$store.state.statusRadio;
      },
      set() {},
    },
  },
  mounted() {
    this.scrollInit();
    this.userType = sessionStorage.getItem("userType");

    if (this.userType == 1) {
      this.source();
    }
    this.titleName = sessionStorage.getItem("zykId") == "cg822ftgluobug6tlobtqpcwnir11145";
    if (this.$route.path === "/schedule" || this.$route.path === "/monitorIndexDataTrack")
      this.showSaveBtn = true;
    if (this.$route.path === "/monitorIndexDataTrack") this.showExportBtn = true;
  },
  watch: {
    // 监听侧边栏收缩时调整图表
    isCollapse() {
      this.isRouterAlive = true;
      this.reload();
    },
    // 监听路由变化
    $route(to) {
      if (to.path === "/schedule") {
        this.showSaveBtn = true;
        this.showExportBtn = false;
      }
      else if (to.path === "/monitorIndexDataTrack") {
        this.showSaveBtn = true;
        if (!to.query.showExportBtn) this.showExportBtn = true;
      } else {
        this.showSaveBtn = false;
        this.showExportBtn = false;
      }
    },
  },
  methods: {
    ...mapMutations(["updateStatusRadio"]),
    // 侧边栏收缩
    stowSidebar() {
      this.isCollapse = !this.isCollapse;
    },
    reload() {
      // 切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 切换专业
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            // 获取专业名称
            const Target = this.dataSourcesList.find((item) => item.zykId == e);
            let str = Target.zykName;
            const i = str.indexOf(" ");
            str = str.slice(i + 1, str.length);
            sessionStorage.setItem("zykName", str);
            sessionStorage.setItem("zykNum", Target.zykNum);
            sessionStorage.setItem("zykId", e);
            this.reload();
          }
        });
    },
    // 切换 国家级/省级 单选按钮
    radioChange(value) {
      this.updateStatusRadio(value);
      this.source(true); //获取专业数据
    },
    // 获取专业数据
    source(flag) {
      this.$axios
        .post(this.$apiurls.major_getAllZykList, this.statusRadio, { loading: false })
        .then((res) => {
          if (res.data) {
            this.dataSourcesList = res.data;
            // 首次更新 下拉框资源切换
            const str = this.dataSourcesList[7].zykName.indexOf(" ");
            const a = this.dataSourcesList[7].zykName.slice(str + 1, str.length);

            sessionStorage.setItem("zykName", a);
            sessionStorage.setItem("zykNum", this.dataSourcesList[7].zykNum);

            // 把拿到的数组存入   sessionStorage
            sessionStorage.setItem("zykArr", JSON.stringify(this.dataSourcesList));
            if (!flag) {
              if (!this.formResourceBase.dataSourcess && !sessionStorage.getItem("zykId")) {
                this.formResourceBase.dataSourcess = this.dataSourcesList[0].zykId;
                sessionStorage.setItem("zykId", this.dataSourcesList[0].zykId);
              } else {
                this.formResourceBase.dataSourcess = sessionStorage.getItem("zykId");
              }
            } else {
              this.formResourceBase.dataSourcess = this.dataSourcesList[0].zykId;
              sessionStorage.setItem("zykId", this.dataSourcesList[0].zykId);
              this.dataChange(this.dataSourcesList[0].zykId);
            }
          }
        });
    },
    // 退出
    signOut() {
      this.isSignOut = true;
      this.$store.commit("modifyVague", true);
      this.$confirm("确定退出登录吗?", "退出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$router.replace("/");
          sessionStorage.clear();
          this.$store.commit("modifyVague", false);
          this.isSignOut = false;
        })
        .catch(() => {
          this.$store.commit("modifyVague", false);
          this.isSignOut = false;
          // this.$message({
          //   type: 'info',
          //   message: '已取消退出！'
          // });
        });
    },
    // 点击启用全屏或非全屏模式
    full() {
      screenfull.toggle();
      this.isFull = !this.isFull;
      this.$store.commit("modifyScreen", this.isFull);
    },
    // 点击保存按钮
    saveTable() {
      this.$refs.child.getTableData();
    },
    // 点击导出按钮
    exportTable() {
      this.$refs.child.exportBuildBaseInfo();
    },
    // 点击导出Excel
    exportExcel(){
      this.$refs.child.exportBuildBaseManageInfo();
    },
    // 关闭tages
    closeTab(index) {
      this.tagsList = JSON.parse(sessionStorage.getItem("tagsList"));
      const closeValue = this.tagsList[index];
      this.tagsList.splice(index, 1);
      let name = "";
      let path = "";
      if (this.tagsList[index]) {
        path = this.tagsList[index].path;
        name = this.tagsList[index].name;
      } else {
        path = this.tagsList[this.tagsList.length - 1].path;
        name = this.tagsList[this.tagsList.length - 1].name;
      }

      if (closeValue.path === this.$route.path) {
        this.tagsMenu.path = path;
        this.tagsMenu.name = name;
        this.activeTab = path;
        this.$router.push({ path });
      }

      sessionStorage.setItem("selectMenu", JSON.stringify(this.tagsMenu));
      sessionStorage.setItem("tagsList", JSON.stringify(this.tagsList));
      this.visible = false;
    },
    // 点击tages
    clickTab(item) {
      this.tagsList = JSON.parse(sessionStorage.getItem("tagsList"));
      this.activeTab = item.path;
      this.tagsMenu.path = item.path;
      this.tagsMenu.name = item.name;
      if (this.$route.path !== item.path) {
        this.$router.push({ path: item.path });
      }
      sessionStorage.setItem("selectMenu", JSON.stringify(this.tagsMenu));
    },
    // 鼠标右击
    // rightMouse(e, item, index) {
    //   if (item.path !== '/essential') {
    //     this.mouse.left = e.clientX;
    //     this.mouse.top = e.clientY;
    //     this.visible = true;
    //     document.addEventListener("click", () => {
    //       this.visible = false;
    //     });
    //   }
    // },
    // 点击关闭其他
    // closeOther() {
    //   var tagsMenu = JSON.parse(sessionStorage.getItem('selectMenu'))
    //   var tagsList = []
    //   tagsList.push({
    //     name: "基本信息",
    //     path: "/essential"
    //   })
    //   if (tagsMenu.path !== '/essential') {
    //     tagsList.push(tagsMenu)
    //   }
    //   this.tagsList = tagsList
    //   sessionStorage.setItem('tagsList', JSON.stringify(tagsList))
    // },
    // 关闭所有
    // closeAll() {
    //   var tagsList = []
    //   tagsList.push({
    //     name: "基本信息",
    //     path: "/essential"
    //   })
    //   this.activeTab = '/essential'
    //   this.tagsMenu.path = '/essential'
    //   this.tagsMenu.name = '基本信息'
    //   this.$router.push({ path: '/essential' })
    //   this.tagsList = tagsList
    //   sessionStorage.setItem('selectMenu', JSON.stringify(this.tagsMenu))
    //   sessionStorage.setItem('tagsList', JSON.stringify(tagsList))
    // },
    // 左切换
    arrowCutLeft() {
      const scrollDiv = this.$refs.elscrollbar.$refs.wrap;
      scrollDiv.scrollLeft -= 100;
    },
    // 右切换
    arrowCutRight() {
      const scrollDiv = this.$refs.elscrollbar.$refs.wrap;
      scrollDiv.scrollLeft += 100;
    },

    // 滚动条
    scrollInit() {
      // 获取要绑定事件的元素
      const scrollDiv = this.$refs.elscrollbar.$refs.wrap;
      document.addEventListener("DOMMouseScroll", handler, false);
      // 添加滚轮滚动监听事件，一般是用下面的方法，上面的是火狐的写法
      scrollDiv.addEventListener("mousewheel", handler, false);
      // 滚动事件的出来函数
      function handler(event) {
        // 获取滚动方向
        const detail = event.wheelDelta || event.detail;
        // 定义滚动方向，其实也可以在赋值的时候写
        const moveForwardStep = 1;
        const moveBackStep = -1;
        // 定义滚动距离
        let step = 0;
        // 判断滚动方向,这里的100可以改，代表滚动幅度，也就是说滚动幅度是自定义的
        if (detail < 0) {
          step = moveForwardStep * 30;
        } else {
          step = moveBackStep * 30;
        }
        // 对需要滚动的元素进行滚动操作
        scrollDiv.scrollLeft += step;
      }
    },

    // 递归菜单数组
    arrayToJson(treeArray) {
      const r = [];
      const tmpMap = {};
      for (var i = 0, l = treeArray.length; i < l; i++) {
        // 以每条数据的id作为obj的key值，数据作为value值存入到一个临时对象里面
        // treeArray[i].suIcon = treeArray[i].icon
        // treeArray[i].uicon = treeArray[i].icon
        treeArray[i].path = treeArray[i].name;
        treeArray[i].name = treeArray[i].title;
        tmpMap[treeArray[i].id] = treeArray[i];
      }
      for (i = 0, l = treeArray.length; i < l; i++) {
        const key = tmpMap[treeArray[i].parentId];
        // 循环每一条数据的 fid，假如这个临时对象有这个key值，就代表这个key对应的数据有children，需要Push进去
        // 如果这一项数据属于哪个数据的子级
        if (key) {
          // 如果这个数据没有children
          if (!key.children) {
            key.children = [];
            key.children.push(treeArray[i]);
            // 如果这个数据有children
          } else {
            key.children.push(treeArray[i]);
          }
        } else {
          // 如果没有这个Key值，就代表找不到属于哪个数据，那就代表没有父级,直接放在最外层
          r.push(treeArray[i]);
        }
      }
      return r;
    },

    // 递归菜单是否到最后一层菜单
    lastMenu(array) {
      let obj;
      if (array[0].children && array[0].children.length) {
        obj = this.lastMenu(array[0].children);
      } else {
        obj = array[0];
      }
      return obj;
    },

    // 路由菜单
    routerlist() {
      // var menuList = this.$store.state.menuList
      this.routerList = [];
      this.routerList = this.arrayToJson(
        JSON.parse(this.$Utils.demoResponse(sessionStorage.getItem("menu")))
      );
      if (!sessionStorage.getItem("tagsList")) {
        const obj = this.lastMenu(this.routerList.length > 0 ? this.routerList[0].children : []);
        this.tagsMenu.path = obj.path;
        this.tagsList.push({
          name: obj.name,
          path: obj.path,
        });
        this.activeTab = obj.path;
        this.$router.replace(this.activeTab);
      }
    },
    // 选中的菜单
    selectMenu(index) {
      const isTrue = this.tagsList.findIndex((item) => item.path === index);

      this.tagsMenu = {
        name: "",
        path: "",
      };

      // 动态路由，中没有首页了
      this.routeMenu.forEach((item) => {
        if (item.name === index) {
          this.tagsMenu.path = item.name;
          this.tagsMenu.name = item.title;
        }
      });

      if (isTrue == -1) {
        this.tagsList.push(this.tagsMenu);
      }
      this.activeTab = index;
      sessionStorage.setItem("selectMenu", JSON.stringify(this.tagsMenu));
      sessionStorage.setItem("tagsList", JSON.stringify(this.tagsList));
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/custom.scss" scoped></style>
<style lang="scss" scoped>
.mainPage {
  background: #091029;
}

.el-header {
  position: relative;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-aside {
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
  background: #091029;
  padding-left: 15px;
  overflow-x: hidden;
}

.el-main {
  position: absolute;
  /* left: 280px; */
  right: 0;
  top: 60px;
  bottom: 0;
  overflow-y: scroll;
  overflow: hidden;
  background: #091029;
  padding: 0px;
}

.footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  height: 60px;
  background: #1bf6f8;
  z-index: 2;
}

/* 头部 */
.header_left {
  color: #fff;
  display: flex;
  align-items: center;
}

.header_left i {
  display: inline-block;
  color: #fff;
  width: 32px;
  height: 32px;
}

.header_left .colleges {
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  margin: 0px 10px;
  font-size: 18px;
  /* color: #4387d6; */
  color: rgb(216, 213, 213);
}

.header_left .colleges .pull_down {
  font-size: 11px;
}

/* 下拉 */
.table-search-box {
  height: 40px;
}

.user_name {
  margin-right: 23px;
  opacity: 0.8;
}

.header_right {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  padding-top: 15px;
}

/* 侧边栏 */
.gadget {
  width: 15px;
  height: 98%;
  position: absolute;
  top: 10px;
  left: 2px;
  z-index: 99;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  cursor: pointer;
}

.gadget:hover {
  background: rgba(20, 26, 51, 0.9);
  color: #fff;
}

.aside_menu {
  width: 90%;
  height: calc(100vh - 70px);
  /* margin: 0px auto; */
  padding: 0px 13px;
  border-radius: 4px;
  margin-top: 10px;
  overflow-y: auto;
}

.el-aside ::v-deep .el-menu {
  background: rgba(0, 0, 0, 0);
  border-right-width: 0px;
  padding-top: 15px;
}

.el-submenu .el-menu-item {
  min-width: 100%;
}

.el-submenu,
.el-menu-item {
  background: linear-gradient(270deg, rgba(128, 176, 255, 0) 0%, rgba(59, 134, 255, 0.1) 100%);
  border-radius: 4px;
}

.is-opened {
  background: #1a284a;
}

/* 侧边栏子菜单背景透明 */
.el-submenu ::v-deep .el-submenu {
  background: rgba(0, 0, 0, 0);
  margin: 0px;
}

.el-submenu {
  margin: 10px 0px;
}

.el-submenu ::v-deep .el-submenu__title,
.el-menu .el-menu-item {
  color: #fff;
  border: 1px solid transparent;
  border-right-color: #1a284a;
}

.el-submenu ::v-deep .el-submenu__title {
  border-right-color: transparent;
}

.el-menu li:nth-child(3) {
  border-right-color: #161c34;
}

.el-menu li:first-child .el-menu--inline li:nth-child(3) {
  border-right-color: #1a284a;
}

.el-menu li:first-child .el-menu--inline li:nth-child(3):hover {
  border-right-color: #1bf6f8;
}

::v-deep .el-menu-item-group__title {
  padding: 0px;
}

/* 侧边栏悬停变色 */
.el-menu .el-submenu ::v-deep .el-submenu__title:hover,
.el-menu .el-menu-item:hover {
  background: rgba(0, 0, 0, 0);
  border: 1px solid #1bf6f8;
  border-radius: 4px;
}

/* 侧边栏选中变色 */
.el-menu-item {
  background-color: rgba(0, 0, 0, 0);
  border-right: 0px solid transparent;
}

.el-menu-item.is-active {
  background: linear-gradient(270deg, rgba(52, 139, 231, 0) 0%, #1bf6f8 100%) !important;
  border-radius: 4px;
  border-right-width: 0px;
}

/* 侧边栏文字箭头调整角度 */
.el-aside ::v-deep .el-submenu__icon-arrow {
  transform: rotate(-90deg) !important;
}

.el-aside ::v-deep .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  transform: rotate(0deg) !important;
}

/* 最外层选中下拉 */
/* .el-aside .aside_menu ::v-deep .el-submenu.is-opened > .el-submenu__title {
  background: linear-gradient(270deg, rgba(52, 139, 231, 0) 0%, #1bf6f8 100%);
  border-right-width: 0px;
}

.el-aside .aside_menu ::v-deep .el-submenu.is-opened > .el-submenu__title:hover {
  border-right-width: 1px;
} */

.aside_Virtualization {
  background: rgba(255, 255, 255, 0.05);
  filter: blur(1px);
  position: fixed;
  top: 70px;
  left: 15px;
  /* width: 265px; */
  height: 100%;
}

/* 中间内容 */
/* 地球图片 */
.bgSpherical {
  width: 60%;
  position: absolute;
  top: 2%;
  right: 5%;
  z-index: 1;
}

.content-box {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 10px;
  bottom: 0;
  /* padding-bottom: 50px; */
  -webkit-transition: left 0.3s ease-in-out;
  transition: left 0.3s ease-in-out;
  padding: 0px 20px;
  z-index: 2;
}

.roll_page {
  width: auto;
  height: calc(100% - 98px);
  box-sizing: border-box;
  position: relative;
  /* background: antiquewhite; */
}

.isFullscreen {
  width: auto;
  height: calc(100% - 30px);
  /* background: aqua; */
}

.footer {
  width: 100%;
  height: 30px;
  position: absolute;
  bottom: 0px;
  background: #091029;
  color: #fff;
}

.footer_text {
  width: 100%;
  height: 100%;
  padding-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}

/* tag导航栏 */
.tabBar {
  width: 100%;
  height: 48px;
  margin-bottom: 20px;
  position: relative;
}

.tabBar_Virtualization {
  background: rgba(35, 42, 67, 0.9);
  /* filter: blur(1px); */
  position: absolute;
  top: -1%;
  left: 0%;
  width: 100%;
  height: 110%;
  z-index: 1;
}

.tabBar_roll {
  width: 93%;
  white-space: nowrap;
  overflow-x: auto;
  position: relative;
  z-index: 2;
}

/* 修改滚动条样式 */
.tabBar_roll ::v-deep ::-webkit-scrollbar {
  width: 10px;
  height: 3px !important;
}

.tabBar_roll ::v-deep.el-scrollbar__wrap {
  margin-right: -11px !important;
}

.tabBar_roll ::v-deep.el-scrollbar__wrap::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgba(182, 182, 182, 0.3);
}

::v-deep .el-scrollbar__bar.is-horizontal {
  height: 0px;
}

.el-tag {
  margin: 10px 5px 12px;
  padding: 0px 15px 0px 10px;
  background: linear-gradient(270deg, rgba(128, 176, 255, 0) 0%, rgba(59, 134, 255, 0.1) 100%);
  border-radius: 4px;
  border: 0px;
  font-size: 14px;
  color: #fff;
  position: relative;
}

.el-tag .icon-whiteIcon {
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: middle;
}

.el-tag:first-child {
  margin-left: 10px;
}

.el-tag:last-child {
  margin-tight: 0px;
}

.el-tag ::v-deep .el-tag__close {
  color: #fff;
  font-size: 19px;
}

.el-icon-setting {
  padding: 0px 5px;
}

.acitveTags {
  background: linear-gradient(270deg, rgba(52, 139, 231, 0) 0%, #1bf6f8 100%);
  border-radius: 4px;
  border-right-width: 0px;
}

.acitveTags ::v-deep .el-tag__close {
  /* color: #ff006f; */
  font-size: 19px;
}

.el-tag ::v-deep .el-tag__close:hover {
  background: transparent;
}

.el-tag ::v-deep .el-tag__close:hover {
  color: #ff006f;
}

.tagesDropdown {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 111;
}

/* 右键弹出Tag标签菜单 */
.rightMouse {
  position: fixed;
  background: white;
  box-shadow: 1px 1px 4px #888;
  font-size: 12px;
  border-radius: 5px;
  z-index: 999;
  color: #000;
  line-height: 30px;
}

.rightMouse > div {
  padding: 0px 10px;
  cursor: pointer;
}

.rightMouse > div:hover {
  background-color: #eeeeee;
  border-radius: 5px;
}

/* 左右箭头切换 */
.arrowCut {
  position: absolute;
  top: 0%;
  right: 0%;
  z-index: 22;
  color: #1bf6f8;
  height: 100%;
  width: 7%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 20px;
}

.vague {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0%;
  left: 0%;
  background: rgba(255, 255, 255, 0);
}

.arrowCut i {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: 100% 100%;
}

.arrowCut i {
  position: relative;
  z-index: 11;
}

.icons {
  width: 24px;
  height: 23px;
  display: inline-block;
  margin-right: 10px;
}

/* 全屏按钮 */
.screen {
  position: fixed;
  bottom: 30px;
  right: 35px;
  background: #2d3757;
  z-index: 11;
  padding: 10px 10px;
  border-radius: 6px;
  color: #409eff;
  font-size: 12px;
  border: 1px solid #2d3757;
  display: flex;
  justify-content: center;
  align-items: center;
}

.screen:hover {
  background: #2a3f74;
}

.backtops {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 99999999999999999999;
  background: #409eff;
}

.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(15, 22, 47, 0.8);
  filter: blur(5px);
  z-index: 10;
}
.center-btn {
  position: absolute;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  .btn-save {
    width: 88px;
    height: 34px;
    background-color: #409eff;
    margin-left: 20px;
    &:hover {
      background-color: #66b1ff;
    }
  }
}
</style>
